/**
 * @desc 根据dono 获取装箱
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.RPCInDeliveryDetailBoxDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/getInDeliveryDetailBox`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
